import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Divider,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose, } from 'recompose';
import { connect } from 'react-redux';
import { pingServices } from 'store/actions';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import { sendClientLog } from 'services/logService';
import CloseableDialogTitle from 'components/layout/CloseableDialogTitle';

const ServicesHealthDialog = ({ classes, servicesStatus, pingServices, open, onClose, isMobile, ...props}) => {
  useEffect(() => {
    if (open) {
      sendClientLog('Info', 'User opened Services Status');
      pingServices();
    }
  }, [open]);

  const [selectedService, setSelectedService] = useState(null);

  const onServiceIconClicked = (service) => {
    setSelectedService(service)
  }

  const onServiceDetailsClicked = () => {
    setSelectedService(null)
  }

  return (
    <>

    {
      selectedService &&
      <Dialog aria-labelledby="services-endpoint-details-dialog" open={selectedService != null} maxWidth={'lg'} fullScreen={isMobile}>
      <CloseableDialogTitle id="services-endpoint-details-dialog-title" onClose={onServiceDetailsClicked}>
        <div>
          <Typography variant='h6'>{selectedService.serviceName} Details</Typography>
        </div>
      </CloseableDialogTitle>
      <Divider />
      <DialogContent>

      <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>Data Status</TableCell>
          <TableCell>Endpoint Summary</TableCell>
          <TableCell>Ping Time</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {selectedService.individualResults.map(service => {
          return (
            <TableRow key={service.displayName}>
              <TableCell>{service.dataReturned ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
              <TableCell>{service.displayName}<div style={{ whiteSpace: 'pre-line' }}>{service.url}</div></TableCell>
              <TableCell>{service.elapsedTime.substring(0, service.elapsedTime.length - 4)}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
      </Table>

      </DialogContent>
      </Dialog>
    }

    <Dialog aria-labelledby="services-health-dialog" open={open} onClose={onClose} {...props} maxWidth={'md'} fullScreen={isMobile}>
      <CloseableDialogTitle id="services-health-dialog-title" onClose={onClose}>
        <div>
          <Typography variant='h6'>Services Status</Typography>
          {servicesStatus.timestamp &&
            <Typography variant="subtitle2" className={classes.lastPing}>
              Pinged On: {(new Date(servicesStatus.timestamp))?.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "long", timeZone: "America/Chicago" })}
            </Typography>
          }
        </div>
      </CloseableDialogTitle>
      <Divider />
      <DialogContent className={classes.content} style={servicesStatus.loading ? {display: 'flex'} : null}>

        {
          servicesStatus.loading &&
          <div className={classes.loading}><CircularProgress /></div>
        }

        {
          servicesStatus.data && !servicesStatus.loading &&
          <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Health Status</TableCell>
              <TableCell>Data Status</TableCell>
              <TableCell>Service</TableCell>
              <TableCell>Endpoint</TableCell>
              <TableCell>Ping Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            <TableRow>
              <TableCell>{servicesStatus.revue ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
              <TableCell>{servicesStatus.revue ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
              <TableCell>ReVUe</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
            {servicesStatus.data.filter(a=>a.serviceName === 'Image').map(service => {
              return (
                <TableRow key={service.serviceName}>
                  <TableCell style={{cursor: 'pointer'}} onClick={() => onServiceIconClicked(service)}>{service.isHealthy ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
                  <TableCell style={{cursor: 'pointer'}} onClick={() => onServiceIconClicked(service)}>{service.dataReturned ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
                  <TableCell>{service.serviceName}</TableCell>
                  <TableCell>PIM, S3, M3 and MSR Image endpoints</TableCell>
                  <TableCell>{service.elapsedTime.substring(0, service.elapsedTime.length - 4)}</TableCell>
                </TableRow>
           )})}
            {servicesStatus.data.filter(a=>a.serviceName !== 'Image').map(service => {
              return (
                <TableRow key={service.serviceName}>
                  <TableCell style={{cursor: 'pointer'}} onClick={() => onServiceIconClicked(service)}>{service.isHealthy ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
                  <TableCell style={{cursor: 'pointer'}} onClick={() => onServiceIconClicked(service)}>{service.dataReturned ? <InsertEmoticonIcon className={classes.statusGood} /> : <SentimentVeryDissatisfiedIcon />}</TableCell>
                  <TableCell>{service.serviceName}</TableCell>
                  <TableCell>{service.url}</TableCell>
                  <TableCell>{service.elapsedTime.substring(0, service.elapsedTime.length - 4)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        }
      </DialogContent>
    </Dialog>

    </>
  );
};

const styles = theme => ({
  content: {
    padding: 'initial',
    alignItems: 'center',
    minHeight: 200
  },
  lastPing: {
    paddingTop: 6
  },
  statusGood: {
    color: 'green'
  },
  loading: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  }
});

const mapStateToProps = (state) => {
  return {
    servicesStatus: state.appState.servicesStatus,
    isMobile: state.appState.isMobile,
  }
};

const mapDispatchToProps = (dispatch) => ({
  pingServices: () => dispatch(pingServices())
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ServicesHealthDialog)
